<template>
  <base-section
  id="program"
  >
    <v-container>
    <base-section-heading
    title="Program"
    color="secondary"
    align="left"
    :toColor="true"
    >
<strong>
You can find the technical program in pdf version <a href="LATS2027_Technical_Program.pdf" download>here</a>.
Please check out the news about <a href="/program/keynotes">Keynotes</a>, <a href="/program/invited">Embedded Tutorials</a>, and <a href="/program/tutorials">Tutorials</a>.
<!---Please check out the news about <a href="/program/keynotes">Keynotes</a>, <a href="/program/visionary">Visionary</a>, <a href="/program/invited">Embedded Tutorials</a>, <a href="/program/special-sessions">Special Sessions</a>, and <a href="/program/tutorials">Tutorials</a>.-->
<br><br>
<v-btn
        href="LATS2027_Technical_Program.pdf"
        rounded
        color="primary"
        dark
        download
        style="padding: 15px"
    >
        <v-icon
        left
        dark
        >
        mdi-download
        </v-icon>
        Technical Program
        </v-btn>
</strong>
<br><br><br>
<div
v-for="day in days"
:key="day.title"
>
<h1><strong><span style="color: #6663A6">{{ day.title }}</span></strong></h1>
<br>
<div
v-for="session, i in day.sessions"
:key="i"
>
  <div v-if="session.to">
    <h2>{{session.hours}} {{session.title}}
      (details
      <a :href="session.to">
      here</a>)
    </h2>
  </div>
  <div
  v-else
  >
  <h2>{{session.hours}} {{session.title}}</h2>
  </div>
  <div v-if="session.timeslots">
    <i>{{session.timeslots}}</i>
  </div>
<h3>{{session.optionalTitle}}</h3>
<div v-html="session.authors" />
<div
v-if="session.htmlText"
>
<div v-html="session.htmlText" />
</div>
<div
v-if="session.chair"
>
Session Chair: <i>{{session.chair}}</i>
<br>
</div>
<div
v-if="session.organizer"
>
<h3>Organized by {{session.organizer}}</h3>
<br>
</div>
<div
v-if="session.moderator"
>
<h3>Organized and moderated by {{session.moderator}}</h3>
<br>
</div>
<div
v-if="session.panelists"
>
<h3>Panelists: {{session.panelists}}</h3>
<br>
</div>
<br>
<div
v-if="session.posters"
>
<h2>Short Papers:</h2>
<div
v-for="talk in session.posters"
:key="talk.title"
>
<h4><strong>{{talk.title}}</strong></h4>
<h4><div v-html="talk.authors" /></h4>
<br>
</div>
</div>
<div
v-if="session.case"
>
<h2>Case studies:</h2>
<div
v-for="talk in session.case"
:key="talk.title"
>
<h4><strong>{{talk.title}}</strong></h4>
<h4><div v-html="talk.authors" /></h4>
<br>
</div>
</div>
<div
v-if="session.late"
>
<h2>Late Contributions:</h2>
<div
v-for="talk in session.late"
:key="talk.title"
>
<h4><strong>{{talk.title}}</strong></h4>
<h4><div v-html="talk.authors" /></h4>
<br>
</div>
</div>
<div
v-else
>
<div
v-for="talk in session.talks"
:key="talk.title"
>
<h4><strong>{{talk.title}}</strong></h4>
<h4><div v-html="talk.authors" /></h4>
<br>
</div>
</div>
<br>
</div>
</div>
</base-section-heading>

    </v-container>
  </base-section>
</template>

<script>
import EnhancedProfileCard from "@/components/base/EnhancedProfileCard.vue"

export default {
    name: 'Program',
    components: {
      EnhancedProfileCard,
    },
    data: () => ({
      days: [
        {
          title: "Tuesday March 17th, 2026",
          sessions: [
            {
              hours: "08:00 - 10:00",
              title: "LACW2027 Technical Session",
            },
            {
              hours: "10:00 - 10:30",
              title: "Coffee-break",
            },
            {
              hours: "",
              title: "LATS2027 & LACW2027: Student Activities",
            },
            {
              hours: "10:30 - 12:00",
              title: "Tutorial 1",
              optionalTitle: "SDC in AI devices",
              authors: "Ernesto Sanchez, Politecnico di Torino – Italy",
              to: "program/tutorials",
            },
            {
              hours: "12:30 - 14:00",
              title: "Lunch",
            },
            {
              hours: "",
              title: "LATS2027 & LACW2027: Student Activities",
            },
            {
              hours: "14:00 - 15:30",
              title: "Tutorial 2",
              optionalTitle: "Using Fault Tolerant AI Accelerators into SRAM-FPGAs for Earth Observation",
              authors: "Fernanda Kastensmidt, UFRGS - Brazil",
              to: "program/tutorials",
            },
            {
              hours: "15:30 - 16:00",
              title: "Coffee-break",
            },
            {
              hours: "",
              title: "LATS2027 & LACW2027",
            },
            {
              hours: "16:00 - 17:30",
              title: "Panel \"How Can We Qualify Integrated Circuits for Aerospace Applications in Latin America\"",
              moderator: "Fernanda Kastensmidt, UFRGS - Brazil",
              panelists: "Marcilei Guazzelli, FEI – Brazil; Nilberto Medina, USP – Brazil; Luigi Dilillo, CNRS/University of Montpellier – France; Fernando Fernandes, INRIA - France",
            },
          ],
        },
        {
          title: "Wednesday March 18th, 2026",
          sessions: [
            {
              hours: "",
              title: "LATS2027 – 1st Day",
            },
            {
              hours: "07:30 - 08:30",
              title: "Registration",
            },
            {
              hours: "08:30 - 09:00",
              title: "LATS2027 Opening Session",
              htmlText: "<strong>General Chairs</strong>:<br>&nbsp;&nbsp;&nbsp;&nbsp;Tiago Balen, UFRGS – Brazil<br>&nbsp;&nbsp;&nbsp;&nbsp;Yervant Zorian, Synopsys – USA<br><strong>Vice General Chair</strong>:<br>&nbsp;&nbsp;&nbsp;&nbsp;Paulo Butzen, UFRGS – Brazil<br><strong>Program Chairs</strong>:<br>&nbsp;&nbsp;&nbsp;&nbsp;Leticia Maria Bolzani Pöhls, IHP – Germany<br>&nbsp;&nbsp;&nbsp;&nbsp;Cristina Meinhardt, UFRGS – Brazil<br><strong>Vice Program Chair</strong>:<br>&nbsp;&nbsp;&nbsp;&nbsp;Marcelo Lubaszewski, UFRGS – Brazil",
            },
            {
              hours: "09:00 - 09:45",
              title: "Keynote Talk",
              optionalTitle: "Fault Effect Evaluation and Mitigation in Edge AI systems",
              authors: "Matteo Sonza Reorda, Politecnico di Torino – Italy",
              chair: "Tiago Balen, UFRGS - Brazil",
              to: "program/keynotes",
            },
            {
              hours: "09:45 - 10:45",
              title: "Regular Session 1 - Low-Power and Robust Scan-Based Testing",
              timeslots: "(3 papers: 20 minutes including Q&A)",
              chair: "Erik Larsson, Lund University - Sweden",
              talks: [
                {
                  title: "LA-SCG: Layout-Aware Scan Chain Grouping for Peak Shift Power and IR-Drop Mitigation in Scan-Based Testing",
                  authors: "Rohit Badjatya, Harsh Gupta, Makoto Ikeda, Masahiro Fujita and Virendra Singh",
                },
                {
                  title: "Validating Statistical Delay Test Generation under Timing Variations via SAT-Based ATPG",
                  authors: "Hanieh Jafarzadeh, Jan Dennis Reimer, Hussam Amrouch, Sybille Hellebrand and Hans-Joachim Wunderlich",
                },
                {
                  title: "LPCG: A Capture Activity-Aware Technique for Low-Power Scan Testing",
                  authors: "Rohit Badjatya, Jaydev Bapat, Makoto Ikeda, Masahiro Fujita and Virendra Singh",
                },
              ],
            },
            {
              hours: "10:45 - 11:15",
              title: "Coffee-break",
            },
            {
              hours: "11:15 - 12:15",
              title: "Regular Session 2 - Dependable Microprocessor Architectures",
              timeslots: "(3 papers: 20 minutes including Q&A)",
              chair: "Fernando Fernandes dos Santos, INRIA - France",
              talks: [
                {
                  title: "Enhancing Fault Tolerance in MicroBlaze V Soft-Core Processors: Performance and Reliability Assessment with ESA Benchmark Applications",
                  authors: "Gabriel Camargo, Fabio Benevenuti, José Rodrigo Azambuja, Antonio Carlos Beck and Fernanda Kastensmidt",
                },
                {
                  title: "Characterization of a Fault-Tolerant RISC-V SoC in an SRAM-based FPGA under Proton Irradiation",
                  authors: "Wesley Grignani, Douglas Almeida dos Santos, Carolina Imianosky, Douglas Melo, Frédéric Wrobel and Luigi Dilillo",
                },
                {
                  title: "Design and Reliability Analysis of a Pipeline RISC-V Processor Core",
                  authors: "Douglas A. Santos, Wesley Grignani, Carolina Imianosky, Douglas Melo and Luigi Dilillo",
                },
              ],
            },
            {
              hours: "12:15 - 13:00",
              title: "Embedded Tutorial 1",
              optionalTitle: "Securing Reconfigurable Scan Networks",
              authors: "Erik Larsson, Lund University – Sweden",
              chair: "Sybille Hellebrand, University of Paderborn - Germany",
              to: "program/invited",
            },
            {
              hours: "13:00 - 14:30",
              title: "Lunch",
            },
            {
              hours: "14:30 - 15:15",
              title: "Industrial Keynote 1",
              optionalTitle: "CEITEC SiC power devices: design, manufacture process, test and reliability challenges.",
              authors: "Eric Fabris, CEITEC S.A. – Semiconductors – Brazil",
              chair: "Yervant Zorian, Synopsys - USA",
              to: "program/keynotes",
            },
            {
              hours: "15:15 - 16:15",
              title: "Special Session",
              optionalTitle: "Reliability Assessment of Deep Neural Networks and Accelerators Across Design Stages",
              organizer: "Josie Esteban Rodriguez, Politecnico di Torino - Italy",
              to: "program/special-sessions",
            },
            {
              hours: "16:15 - 16:45",
              title: "Coffee-break",
            },
            {
              hours: "16:45 - 17:25",
              title: "Regular Session 3 - Advanced Modeling for Robust Integrated Circuit Design",
              timeslots: "(2 papers: 20 minutes including Q&A)",
              chair: "Cristina Meinhardt, UFSC - Brazil",
              talks: [
                {
                  title: "An Analysis of Time-Domain Period Jitter due to Random Telegraph Noise in Phase-Locked Loops",
                  authors: "Caroline Garcia and Gilson Wirth",
                },
                {
                  title: "Automatic Enhancement of Cell Models to Enable Conditional Stuck-At Fault Simulation and Pattern Generation",
                  authors: "Reza Khoshzaban, Nikolaos Ioannis Deligiannis, Iacopo Guglielminetti, Michelangelo Grosso and Riccardo Cantoro",
                },
              ],
            },
            {
              hours: "17:25 - 18:45",
              title: "Regular Session 4 - Fault Injection Challenges",
              timeslots: "(4 papers: 20 minutes including Q&A)",
              chair: "Jose Rodrigo Azambuja, UFRGS - Brazil",
              talks: [
                {
                  title: "Emulating SDC-1 Hardware Faults through Application-Level Bit-Flip Injections in QNNs",
                  authors: "Giacomo Perlo, Antonio Porsia, Annachiara Ruospo and Ernesto Sanchez",
                },
                {
                  title: "M-EL2N: Data-Efficient Fault Injection through Sample Difficulty Analysis",
                  authors: "Nicolò Bellarmino, Alberto Bosio, Ahmed Al-Kaf, Mounir Benabdenbi, Régis Leveugle and Riccardo Cantoro",
                },
                {
                  title: "Spectral vs. Spatial Pruning: Fault Resilience Analysis for Extremely Sparse DNNs",
                  authors: "Manar Gani, Leonardo Alexandrino de Melo, Alberto Bosio, David Novo and Rodrigo Possamai Bastos",
                },
              ],
            },
            {
              hours: "19:00 - 22:00",
              title: "Welcome Cocktail",
            },
          ],
        },
        {
          title: "Thursday March 19th, 2026",
          sessions: [
            {
              hours: "",
              title: "LATS2027: 2nd Day",
            },
            {
              hours: "08:30 - 09:15",
              title: "Industrial Keynote 2",
              optionalTitle: "Designing Chiplets & 3DIC for Silicon Lifecycle Management",
              authors: "Yervant Zorian, Synopsys – USA",
              chair: "Matteo Sonza Reorda, Politecnico di Torino - Italy",
              to: "program/keynotes",
            },
            {
              hours: "09:15 - 09:30",
              title: "Vendor Session",
              authors: "RIGOL, Brazil",
            },
            {
              hours: "09:30 - 10:30",
              title: "Regular Session 5 - Advanced Architectures and Reliability Modeling",
              timeslots: "(3 papers: 20 minutes including Q&A)",
              chair: "Luigi Dilillo, CNRS/University of Montpellier - France",
              talks: [
                {
                  title: "Design of a Low-Power High-Density Analog In-Memory Computing Accelerator Using 18 nm FD-SOI Phase-Change Memory",
                  authors: "Valentin Viollet, Guillaume Prenat, Andrea Al Muktash, Lorena Anghel, Catherine Popon and Xavier Lecoq",
                },
                {
                  title: "Fast Statistical Estimation of Circuit-Level Cross Section Considering Logical Masking Effects",
                  authors: "Clayton Farias, Tiago Balen and Paulo F. Butzen",
                },
                {
                  title: "Susceptibility Evaluation of Layout-Based MUX 2:1 Topologies",
                  authors: "Ana Flávia Reis, Eduardo Costa and Rafael Schvittz",
                },
              ],
            },
            {
              hours: "10:30 - 11:00",
              title: "Coffee-break",
            },
            {
              hours: "11:00 - 12:40",
              title: "TTTC McCluskey Best Doctoral Thesis Award",
              talks: [
                {
                  title: "Deploying Compact and Reliable Deep Neural Networks in Safety-critical Applications",
                  authors: "Leonardo Alexandrino de Melo",
                },
                {
                  title: "Automatic Tool for Test Set Generation and DfT Assessment in Analog Integrated Circuits",
                  authors: "Lucas Zilch",
                },
                {
                  title: "Machine Learning Techniques for Microcontrollers Performance Screenings",
                  authors: "Nicolò Bellarmino",
                },
                {
                  title: "Study of the Reliability of Mixed-Signal Interfaces in Programmable Devices for Critical Applications",
                  authors: "Carlos Aguilera",
                },
                {
                  title: "Qualification of Photovoltaic Micromodules Using Time-Domain Reflectometry Electronic Signature Masks for Energy Harvesting Applications",
                  authors: "Allan Mariano Campos da Silveira",
                },
              ],
            },
            {
              hours: "12:40 - 13:45",
              title: "Lunch",
            },
            {
              hours: "14:00 - 17:30",
              title: "Social Event",
            },
            {
              hours: "19:00 - 23:00",
              title: "Gala Dinner",
            },
          ],
        },
        {
          title: "Friday March 20th, 2026",
          sessions: [
            {
              hours: "",
              title: "LATS2027: 3rd Day",
            },
            {
              hours: "09:00 - 09:45",
              title: "Keynote Talk",
              optionalTitle: "Hidden Faults, Visible Failures",
              authors: "Wunderlich, University of Stuttgart – Germany",
              chair: "Marcelo Lubaszewski, UFRGS - Brazil",
              to: "program/keynotes",
            },
            {
              hours: "09:45 - 10:20",
              title: "Poster Session \"Short Papers\"",
              timeslots: "(10 papers: 5 minutes pitch + poster)",
              chair: "Nicolo Bellarmino, Politecnico di Torino - Italy",
              posters: [
                {
                  title: "Towards Reliable and Scalable Firmware Testing in Communication-Constrained Environments",
                  authors: "José Danilo da Silva Coutinho Filho, André Henrique Pontes Dantas, Tiago Diógenes de Araújo, José Edilson Silva Filho, Jarbas Aryel Nunes da Silveira and Alberto Alexandre Moura de Albuquerque",
                },
                {
                  title: "Evaluating an Analog Test Pattern Generation Tool by Means of Hardware-emulated Fault Injection",
                  authors: "Luis Duarte, Tiago Balen, Lucas Zilch, Marcelo Lubaszewski and Allan Ferreira",
                },
                {
                  title: "Enhancing the Lifetime of STT-MRAM in IoT Applications by Current Balancing",
                  authors: "Somayeh Sadeghi Kohan, Fatemeh Akbari, Mahta Mayahinia, Mehdi Tahoori, Sybille Hellebrand and Hans-Joachim",
                },
                {
                  title: "Radiation Robustness Assessment of StrongARM Comparators in 130nm, 65nm and 45nm technologies",
                  authors: "Bianca Nunes Coelho, Thales Stedile-Ribeiro and Tiago Roberto Balen",
                },
                {
                  title: "RESQ: A Unified Framework for REliability- and Security Enhancement of Quantized Deep Neural Networks",
                  authors: "Ali Soltan Mohammadi, Samira Nazari, Ali Azarpeyvand, Mahdi Taheri, Milos Krstic, Michael Hübner, Christian Herglotz and Tara Ghasempouri",
                },
                {
                  title: "Software Diversity in Resource-Constrained Embedded System",
                  authors: "Kush Dave and Ian G. Harris",
                },
                {
                  title: "Soft Error Mitigation in a Real-Time Control System through Hardware Protection on an SRAM-Based FPGA",
                  authors: "Jaime Minaya, Alessandro Giuffra and Jimmy Tarrillo",
                },
                {
                  title: "Automated Testing Tools and Software Reliability: A Systematic Mapping",
                  authors: "Artur Santos de Farias, Rodrigo Gusmão de Carvalho Rocha, Jean Araujo and Felipe Moura",
                },
                {
                  title: "Adaptive Neural Network Optimization of Vehicle Start-Stop Systems Using Digital Twin Framework",
                  authors: "George Flutur, Ovidiu-Petru Stan, Gabriel Chindris and Liviu-Cristian Miclea",
                },
              ],
            },
            {
              hours: "10:20 - 11:20",
              title: "Coffee-break & Short Papers' Posters",
            },
            {
              hours: "11:20 - 12:40",
              title: "Regular Session 6 - Reliable Design: From Process Variability to Robust AI Inference",
              timeslots: "(4 papers: 20 minutes including Q&A)",
              chair: "Ernesto Sanchez, Politecnico di Torino - Italy",
              talks: [
                {
                  title: "Mitigation of SETs under Process Variability Effects: Circuit-Level Strategies for Reliable Design",
                  authors: "Marina Dias, Bernardo Borges Sandoval, Paulo Butzen, Ricardo Reis and Cristina Meinhardt",
                },
                {
                  title: "Resilience Analysis of a Fault-Tolerant MPSoC Interconnection Architecture under SEU Fault Injection",
                  authors: "Thiago Rausch, Wesley Grignani, Luigi Dilillo and Douglas Melo",
                },
                {
                  title: "Impact of Alpha-Induced Single Events on the Inference Confidence of Quantized Neural Networks on Cortex-M",
                  authors: "Leonardo Reinehr Gobatto, Nathan Guimarães, Fabio Benevenuti, Antonio Carlos Beck, Fernanda Kastensmidt and José Rodrigo Azambuja",
                },
                {
                  title: "Fault-Tolerance in FINN-Based CNN Accelerator for In-Orbit Land Cover Classification",
                  authors: "Fabio Benevenuti, Ulisses Maffazioli, Arthur Ely, Eduardo Marañon, Antonio Carlos Beck Filho, José Rodrigo Azambuja and Fernanda Kastensmidt",
                },
              ],
            },
            {
              hours: "12:40 - 14:00",
              title: "Lunch",
            },
            {
              hours: "14:00 - 14:45",
              title: "Embedded Tutorial 2",
              optionalTitle: "Design for Electromagnetic Compatibility and Trust in Integrated Systems: Combining Robustness, Innocuity and Security Concerns",
              authors: "Regis Leveugle, Grenoble INP / TIMA, Université Grenoble Alpes, France",
              chair: "Leticia Maria Bolzani Poehls, IHP - Germany",
              to: "program/invited",
            },
            {
              hours: "14:45 - 14:55",
              title: "Vendor Session",
              authors: "IMPINJ, Brazil",
            },
            {
              hours: "14:55 - 15:40",
              title: "Poster Session \"Case Studies\"",
              timeslots: "(9 papers: 5 minutes pitch + poster)",
              chair: "Paulo Butzen, UFRGS - Brazil",
              case: [
                {
                  title: "Improving the Robustness of Photonic Neural Networks Against Memory Faults",
                  authors: "Mauricio Gomes de Queiroz, Leonardo Alexandrino de Melo, Mateus Vidaletti Costa, Salvatore Pappalardo, Fabio Pavanello, Ian O'Connor and Alberto Bosio",
                },
                {
                  title: "The High-Level Synthesis-Based Firmware Upgrade for the Digital Trigger Back-end System of the ATLAS Liquid Argon Calorimeter",
                  authors: "Melissa Santos Aguiar, Dabson Ferreira dos Santos, Adriana Milic, Marcos Vinícius Silva Oliveira and Luciano Manhães de Andrade Filho",
                },
                {
                  title: "A Robust Bootloader System with Support for Over-the-Air Firmware Updates in CubeSat Payloads",
                  authors: "João Sobreira, Wendell Silva, Cícero Oliveira, Marcus Bezerra and Jarbas Silveira",
                },
                {
                  title: "A Uniform Benchmarking of RISC-V Cores on FPGA: Performance, Power, and Area Analysis",
                  authors: "Joao Carlos Britto Filho and Paulo F. Butzen",
                },
                {
                  title: "Neutron-induced SEE Evaluation in a Mixed-signal Programmable SoC",
                  authors: "Eduardo Fabbris, Rafael Galhardo Vaz, Odair Lelis Gonçalez and Tiago Balen",
                },
                {
                  title: "Preliminary Evaluation of RISC-V Architectures for Resource-constrained Edge Computing Systems",
                  authors: "Pierre-Alexandre Peyronnet, Luiz Henrique Laurini, Emmanuel Atukpor, Jessy Guilbot, Christian Costa and Rodrigo Possamai Bastos",
                },
                {
                  title: "Exploring nMR Implementations for Energy Monitoring in Telecom Base Stations under Non-Ionizing Radiation",
                  authors: "Elian Nevado and Jimmy Tarrillo",
                },
                {
                  title: "Hardening RISC-V Shadow Stacks Against Fault Injection: A Fault-Resilient Implementation on CVA6",
                  authors: "Behnam Farnaghinejad and Ernesto Sanchez",
                },
              ],
            },
            {
              hours: "15:40 - 16:40",
              title: "Coffee-break & Case Study Papers' Posters",
            },
            {
              hours: "16:40 - 18:00",
              title: "Regular Session 7 - Machine Learning and Formal Verification for Reliable Design",
              timeslots: "(4 papers: 20 minutes including Q&A)",
              chair: "Fernanda Kastensmidt, UFRGS - Brazil",
              talks: [
                {
                  title: "PowerCourt: Formally judging benign-looking circuits in multi-tenant FPGA environments",
                  authors: "Philipp Schmitz, Mohamed Shelkamy Ali, Dino Mehmedagić, Hassan Nassar, Jörg Henkel, Dominik Stoffel and Wolfgang Kunz",
                },
                {
                  title: "Deep Learning-Based Power Side-Channel Evaluation from RTL Switching-Activity Proxies",
                  authors: "Behnam Farnaghinejad, Annachiara Ruospo, Alessandro Savino, Stefano Di Carlo and Ernesto Sanchez",
                },
                {
                  title: "Convolutional Neural Networks for Energy Estimation in High-Energy Calorimetry",
                  authors: "Diogo Cardinot, Bernardo Peralva, Gustavo Libotte and Luciano Filho",
                },
                {
                  title: "Assessing the Limitations of Activation Clipping for Fault Mitigation in Vision and Language Transformers",
                  authors: "Lucas Roquet, Fernando Fernandes dos Santos, Luigi Carro and Angeliki Kritikakou",
                },
              ],
            },
            {
              hours: "18:00 - 18:30",
              title: "Closing Session",
            },
          ],
        },
      ],
    }),
};
</script>

<style>
.v-application .grey--text.text--darken-1 {
  color: black !important;
}
.v-application .grey--text.text--lighten-1 {
  color: white !important;
}
.v-card {
  word-break: unset !important;
}
h4 {
  font-weight: unset;
}
</style>
